import {useEffect} from 'react';

import styled from 'styled-components';

import {LoginOrRegister} from '~/shared/components/SignIn';
import {attachModal} from '~/shared/components/ReduxModal';
import {eventNames, on} from '~/shared/events';
import {PopupModalBase} from '~/shared/components/Modals';

const Root = styled(PopupModalBase)`
  &&& {
    background-color: ${({theme}) => theme.colors.surface};
    width: 505px;
    overflow: auto;
  }
`;

const LoginOrRegisterModal = ({scrollModalToBottom, closeModal, args = {}}) => {
  const {mode, onSuccess, fromCheckout} = args;

  useEffect(() => {
    const offLogin = on(eventNames.login, closeModal);
    return () => {
      offLogin();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root>
      <LoginOrRegister
        scrollModalToBottom={scrollModalToBottom}
        closeModal={closeModal}
        mode={mode}
        onSuccess={onSuccess}
        fromCheckout={fromCheckout}
      />
    </Root>
  );
};

LoginOrRegisterModal.hideCloseButton = true;
export default attachModal('loginOrRegister', LoginOrRegisterModal);
